module.exports = __webpack_public_path__ + "static/03-2-a1ec83fade06817bdfa82bbcc4a74012.jpg";